module.exports = __webpack_public_path__ + "static/img/3.54d33e0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/21/zh/3.png
// module id = 980k
// module chunks = 0